import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get('/prospects', {params: {...filter}})
  },

  create(prospect){
    return Http.post(`/prospects`, {prospect: {...prospect}})
  },

  update(prospect){
    return Http.put(`/prospects/${prospect.id}`, {prospect: {...prospect}})
  },

  show(id) {
    return Http.get(`/prospects/${id}`);
  }, 

  delete(id){
    return Http.delete(`/prospects/${id}`)
  }

}